import { render, staticRenderFns } from "./SvmCoordinates.vue?vue&type=template&id=2aaa13d2&scoped=true&"
import script from "./SvmCoordinates.vue?vue&type=script&lang=js&"
export * from "./SvmCoordinates.vue?vue&type=script&lang=js&"
import style0 from "./SvmCoordinates.vue?vue&type=style&index=0&id=2aaa13d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaa13d2",
  null
  
)

export default component.exports